import { render, staticRenderFns } from "./PopupPDF.vue?vue&type=template&id=f1053b6e&scoped=true&"
import script from "./PopupPDF.vue?vue&type=script&lang=js&"
export * from "./PopupPDF.vue?vue&type=script&lang=js&"
import style0 from "pdfvuer/dist/pdfvuer.css?vue&type=style&index=0&lang=css&"
import style1 from "./PopupPDF.vue?vue&type=style&index=1&id=f1053b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1053b6e",
  null
  
)

export default component.exports